import querystring from 'querystring'

export default () => {
    return querystring.stringify({
        refresh_token: localStorage.getItem('refresh_token'),
        grant_type: "refresh_token"
    })
}